export default __webpack_public_path__ + "static/media/tune_upwards1.c5f92f51.jpg";